export const IN_STATIONING_PLACE = "IN_STATIONING_PLACE";
export const OUTSIDE_STATIONING_PLACE = "OUTSIDE_STATIONING_PLACE";
